import { Container, Grid, Typography, Card, CardContent } from '@mui/material';
import { GraduationCap, Rocket, Zap, Building2, Lightbulb } from 'lucide-react';
import getStyles from './styles';

const AudienceSection = () => {
  const styles = getStyles();

  const audience = [
    {
      icon: GraduationCap,
      title: 'College Students',
      desc: 'Who want real-world exposure instead of memorising theory — and are ready for project-based learning'
    },
    {
      icon: Rocket,
      title: 'Early Career Aspirants',
      desc: 'Early professionals seeking real-world leadership exposure, strategic thinking skills, and a fellowship that helps them grow faster'
    },
    {
      icon: Zap,
      title: 'Self-driven Individuals',
      desc: 'Who take ownership, ask “why not?”, and want a startup fellowship experience that pushes their thinking'
    },
    {
      icon: Building2,
      title: 'Problem Solvers & Builders',
      desc: 'Who notice problems everywhere and want to build solutions — a natural fit for a product thinking fellowship'
    },
    {
      icon: Lightbulb,
      title: 'Future Founders',
      desc: 'Individuals with entrepreneurial ambition who want structured exposure to real-world building, decision-making, and early founder-level responsibility'
    }
  ];

  return (
    <Grid sx={styles.section}>
      <Container maxWidth={'xl'}>
        <Grid sx={styles.container}>
          <Typography variant="h2" sx={styles.title}>
            For Curious Students, Bold Aspirants, <br />
            <span style={styles.primaryText}>
              Quiet Builders, Future Founders
            </span>
          </Typography>
          <Grid sx={styles.cardsContainer}>
            {audience.map((item, idx) => (
              <Card key={idx} sx={styles.card}>
                <CardContent sx={styles.cardContent}>
                  <Grid sx={styles.iconContainer}>
                    <item.icon style={styles.cardIcon} />
                  </Grid>
                  <Typography variant="h3" sx={styles.cardTitle}>
                    {item.title}
                  </Typography>
                  <Typography sx={styles.cardDescription}>
                    {item.desc}
                  </Typography>
                </CardContent>
              </Card>
            ))}
          </Grid>
          <Grid sx={styles.note}>
            <Typography sx={styles.noteText}>
              No technical experience required. Only hunger, curiosity, and
              willingness to execute.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Grid>
  );
};

export default AudienceSection;
